import SettingsLayout from "../Layout";

import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import GeneralTab from "./Tabs/General";

  const tabContent = [
    {panel: "general", content: <GeneralTab />},
  ]

const GeneralSettings = () => {

  const tabs = [
    {label: "General", icon: <ReceiptLongRoundedIcon fontSize="small" />},
  ];

  return (
    <SettingsLayout title="General" tabs={tabs} tabContent={tabContent} url="settings/general">

    </SettingsLayout>
  )
};

export default GeneralSettings;